(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blp-header"]) return;
  try {
    
(() => {
  if (window.blpNavigationReady) return;
  window.blpNavigationReady = true;
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.blp-nav--desktop > details')) return;
    details.parentElement.querySelectorAll(':scope > details[open]').forEach(other => { if (other !== details) other.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const current = document.activeElement.closest('.blp-nav__department[open], .blp-mobile-menu[open]');
    if (current) { current.open = false; current.querySelector('summary').focus(); }
    else document.querySelectorAll('.blp-header details[open]').forEach(details => { details.open = false; });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.blp-header')) document.querySelectorAll('.blp-header details[open]').forEach(details => { details.open = false; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
